var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pencil",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.167,
    height: 21,
    viewBox: "0 0 21.167 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_375",
    "data-name": "Grupo 375",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_546",
    "data-name": "Trazado 546",
    d: "M20.167,15,15,20.167a.507.507,0,0,1-.667,0L.75,6.583a.806.806,0,0,1,0-1.167L5.417.75a.806.806,0,0,1,1.167,0L20.167,14.333A.39.39,0,0,1,20.167,15Z",
    transform: "translate(-0.5 -0.5)",
    fill: "none",
    stroke: "#868686",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_547",
    "data-name": "Trazado 547",
    d: "M23.547,22.955a.394.394,0,0,1-.417.417l-5.3-.082a.048.048,0,0,1-.033-.083l5.551-5.469c.013-.013.035-.008.036.009l.165,5.208",
    transform: "translate(-3.38 -3.372)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_548",
    "data-name": "Trazado 548",
    d: "M23.547,22.955a.394.394,0,0,1-.417.417l-5.3-.082a.048.048,0,0,1-.033-.083l5.551-5.469c.013-.013.035-.008.036.009Z",
    transform: "translate(-3.38 -3.372)",
    fill: "none",
    stroke: "#868686",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_114",
    "data-name": "L\\xEDnea 114",
    y1: 5.833,
    x2: 5.833,
    transform: "translate(3.5 3.417)",
    fill: "none",
    stroke: "#868686",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.f1a7a5b6a56a3b36ec10e7b541b22af0.svg";
export { ForwardRef as ReactComponent };